import { TranslationDictionary } from '../types';

export const en: TranslationDictionary = {
  'ots.seat_entry.hint': 'Enter your seat number to continue.',
  'ots.seat_entry.seat_number': 'Seat Number',
  'ots.seat_entry.placeholder': 'e.g. A12',
  'ots.seat_entry.continue': 'Continue',
  'ots.qr_entry.hint': 'Scan the QR code at your seat to start.',
  'ots.fulfillment.back': 'Back',
  'ots.fulfillment.title': 'How would you like your order?',
  'ots.fulfillment.seat': 'Seat',
  'ots.fulfillment.table': 'Table',
  'ots.fulfillment.delivery_seat.title': 'Delivery to Seat',
  'ots.fulfillment.delivery_table.title': 'Delivery to Table',
  'ots.fulfillment.delivery.hint': 'Staff will bring it to you',
  'ots.fulfillment.delivery.fee': '+[[amount]] service fee',
  'ots.fulfillment.pickup.title': 'Self Pickup',
  'ots.fulfillment.pickup.hint': 'Collect from the concessions counter',
  'ots.fulfillment.pickup.fee': 'No service fee',
  'ots.fulfillment.browse': 'Browse Menu',
  'ots.menu.back': 'Back',
  'ots.menu.search': 'Search',
  'ots.menu.search_placeholder': 'Search menu',
  'ots.menu.view_cart': 'View Cart',
  'ots.menu.delivery': 'Delivery',
  'ots.menu.add': 'Add',
  'ots.menu.remove': 'Remove',
  'ots.menu.tab.all': 'All',
  'ots.menu.tab.popcorn': 'Popcorn',
  'ots.menu.tab.drinks': 'Drinks',
  'ots.menu.tab.snacks': 'Snacks',
  'ots.menu.tab.sweets': 'Sweets',
  'ots.menu.section.beer': 'Beer',
  'ots.menu.section.popcorn': 'Popcorn',
  'ots.menu.section.long-drinks': 'Long Drinks',
  'ots.menu.section.wine': 'Wine',
  'ots.menu.section.cocktails': 'Cocktails',
  'ots.menu.section.soft-drinks': 'Soft Drinks',
  'ots.menu.section.hot-drinks': 'Hot Drinks',
  'ots.menu.section.snacks': 'Snacks',
  'ots.menu.section.sweets': 'Sweets',
  'ots.menu.item.beer-pils': 'Pils',
  'ots.menu.item.popcorn-sweet': 'Sweet Popcorn',
  'ots.menu.item.wine-white': 'White Wine',
  'ots.menu.item.wine-red': 'Red Wine',
  'ots.menu.item.wine-green': 'Green Wine',
  'ots.menu.item.wine-prosecco': 'Prosecco Wine',
  'ots.menu.item.cola': 'Cola',
  'ots.menu.item.nachos': 'Nachos',
  'ots.menu.item.m-and-m': 'M&M',
  'ots.cart.title': 'Your order',
  'ots.cart.close': 'Close',
  'ots.cart.checkout': 'Proceed to Checkout',
  'ots.checkout.back': 'Back',
  'ots.checkout.title': 'Checkout',
  'ots.checkout.summary': 'Order Summary',
  'ots.checkout.line': '[[qty]]x [[name]]',
  'ots.checkout.subtotal': 'Subtotal',
  'ots.checkout.service_fee': 'Service fee',
  'ots.checkout.total': 'Total',
  'ots.checkout.delivered_seat': 'Delivered to your seat',
  'ots.checkout.delivered_table': 'Delivered to your table',
  'ots.checkout.pickup_counter': 'Pickup at counter',
  'ots.checkout.details': 'Your Details',
  'ots.checkout.name': 'Your Name',
  'ots.checkout.name_placeholder': 'Sarah Mitchell',
  'ots.checkout.payment': 'Payment',
  'ots.checkout.payment.paypal': 'PayPal',
  'ots.checkout.payment.apple_pay': 'Apple Pay',
  'ots.checkout.payment.credit_card': 'Credit Card',
  'ots.checkout.payment.google_pay': 'Google Pay',
  'ots.checkout.pay': 'Pay [[amount]]',
  'ots.confirm.title': 'Order Confirmed!',
  'ots.confirm.hint': 'Your order is now with the cinema team.',
  'ots.confirm.order': 'Order',
  'ots.confirm.eta.delivery': 'Estimated: 15–20 min',
  'ots.confirm.eta.pickup': 'Estimated: 10 min',
  'ots.confirm.eta.ready_pickup': 'Ready for pickup',
  'ots.confirm.eta.ready_delivery': 'On the way to your seat',
  'ots.confirm.step.received': 'Order Received',
  'ots.confirm.step.preparing': 'Preparing Your Order',
  'ots.confirm.step.on_the_way': 'On the Way to Your Seat',
  'ots.confirm.step.ready': 'Ready for Pickup',
  'ots.confirm.total_paid': 'Total paid',
  'ots.confirm.new_order': 'Start New Order',
  'ots.staff.title': 'Staff Dashboard',
  'ots.staff.total': '[[count]] orders total',
  'ots.staff.total.one': '[[count]] order total',
  'ots.staff.search': 'Search',
  'ots.staff.search_placeholder': 'Type here',
  'ots.staff.search_submit': 'Suchen',
  'ots.staff.filters': 'Filters',
  'ots.staff.filters.status': 'Status',
  'ots.staff.column': '[[label]] ([[count]])',
  'ots.staff.column.new': 'NEW',
  'ots.staff.column.preparing': 'PREPARING',
  'ots.staff.column.ready': 'READY FOR DELIVERY',
  'ots.staff.column.done': 'DONE',
  'ots.staff.status.new': 'New',
  'ots.staff.status.preparing': 'Preparing',
  'ots.staff.status.ready': 'Ready for Delivery',
  'ots.staff.status.ready_pickup': 'Ready for Pickup',
  'ots.staff.status.done': 'Done',
  'ots.staff.meta': '[[minutes]] min ago · [[name]]',
  'ots.staff.meta.now': 'Just now · [[name]]',
  'ots.staff.line': '[[qty]]× [[name]]',
  'ots.staff.fulfillment.pickup': 'Pickup',
  'ots.staff.action.prepare': 'Start Preparing',
  'ots.staff.action.ready': 'Mark Ready for Delivery',
  'ots.staff.action.ready_pickup': 'Mark Ready for Pickup',
  'ots.staff.action.delivered': 'Mark Delivered',
  'ots.staff.action.received': 'Mark Received',
  'ots.staff.completed': 'Completed',
  'ots.staff.item.popcorn_butter_large': 'Butter Popcorn (Large)',
  'ots.staff.item.smash_burger': 'Smash Burger'
};
